// extracted by mini-css-extract-plugin
export default {"bodyWrap":"WorkspaceTab_bodyWrap__NM-Su","item":"WorkspaceTab_item__QtXj9","item__left":"WorkspaceTab_item__left__UnZhr","item__right":"WorkspaceTab_item__right__oVaIJ"};